import Swiper, {Navigation, Pagination, Autoplay, Keyboard} from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, Keyboard]);

const swiper = new Swiper(".foundation-quote__swiper", {
        // slidesPerView: "auto",
        slidesPerView: 1,
        spaceBetween: 20,
        autoHeight: false,
        loop: false,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints:{
            800: {
                slidesPerView: 2,
            }
        }

});
